import { MONTH_ARRAY } from './constants';

export const getMonthStringFromInt = (birthMonth: number): string => {
  if (!birthMonth) return '';
  return MONTH_ARRAY[birthMonth - 1];
};
